import { AfterViewInit, Component, OnDestroy, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationInfo } from '../../models/navigation-info';
import { Project } from '../../models/project';
import { HttpService } from '../../services/http/http.service';
import { StatusType } from './../../models/enums';
import { StatusNavigationContentComponent } from './../../models/status-navigation-content-component';
import { CommonService } from './../../services/common/common.service';
import { RestService } from './../../services/rest/rest.service';
import { GenericTreeNode } from './../generic-tree/generic-tree-node';
import { GenericTreeComponent } from './../generic-tree/generic-tree.component';
import { ObjectActionListType, PermissionSet } from '../../models/permission';

@Component({
    standalone: false,
    selector: 'res-status-management',
    templateUrl: './status-management.component.html',
    styleUrls: ['./status-management.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class StatusManagementComponent implements AfterViewInit, OnDestroy {
    @ViewChild('statusTree', { static: true }) statusTree: GenericTreeComponent;

    modalAutomationId = 'status-management';
    modalClass = 'status-management';

    nodes: Array<GenericTreeNode> = [
        new GenericTreeNode({
            name: '',
            automationId: 'org-settings-tree-general',
            isExpandable: true,
            isExpanded: true,
            isExpandedOnSelect: true,
            isSelectable: false,
            hideExpander: true,

            children: [
                new GenericTreeNode({
                    name: 'Job Management',
                    automationId: 'status-tree-job-management',
                    icon: 'fa-tasks',
                    iconColor: 'color-purple-03',
                    childPadding: 5,
                    navigationInfo: new NavigationInfo({ name: '', path: 'status-job-management', default: true }),
                    permissions: [new PermissionSet({ permissionType: ObjectActionListType.JOB_MANAGEMENT })]
                }),
                new GenericTreeNode({
                    name: 'Job and Error History',
                    automationId: 'status-tree-job-history',
                    icon: 'fa-history',
                    iconColor: 'color-purple-03',
                    childPadding: 5,
                    navigationInfo: new NavigationInfo({ name: '', path: 'status-job-history' }),
                    permissions: [new PermissionSet({ permissionType: ObjectActionListType.JOB_AND_ERROR_HISTORY })]
                }),
                new GenericTreeNode({
                    name: 'Active User Sessions',
                    automationId: 'status-tree-active-user-sessions',
                    icon: 'fa-user',
                    iconSecond: 'fa-clock-o',
                    iconColor: 'color-green-05',
                    childPadding: 5,
                    navigationInfo: new NavigationInfo({ name: '', path: 'status-active-user-sessions' }),
                    permissions: [new PermissionSet({ permissionType: ObjectActionListType.ACTIVE_USER_SESSIONS })]
                }),
                new GenericTreeNode({
                    name: 'Project Access History',
                    automationId: 'status-tree-project-access-history',
                    icon: 'fa-book',
                    iconColor: 'color-grey-08',
                    iconSecond: 'fa-history custom',
                    iconSecondColor: 'color-purple-03',
                    childPadding: 5,
                    navigationInfo: new NavigationInfo({ name: '', path: 'status-project-access-history' }),
                    permissions: [new PermissionSet({ permissionType: ObjectActionListType.PROJECT_ACCESS_LOG })]
                }),
                new GenericTreeNode({
                    name: 'System Audit Log',
                    automationId: 'status-tree-system-audit-log',
                    icon: 'fa-gear',
                    iconSecond: 'fa-history',
                    iconColor: 'color-grey-08',
                    iconSecondColor: 'color-purple-03',
                    childPadding: 5,
                    navigationInfo: new NavigationInfo({ name: '', path: 'status-system-audit-log' }),
                    permissions: [new PermissionSet({ permissionType: ObjectActionListType.SYSTEM_AUDIT_LOG })]
                }),
                new GenericTreeNode({
                    name: 'Monitoring',
                    automationId: 'status-tree-montoring',
                    icon: 'fa-dashboard',
                    iconColor: 'color-blue-01',
                    childPadding: 5,
                    navigationInfo: new NavigationInfo({ name: '', path: 'status-monitoring' }),
                    permissions: [new PermissionSet({ permissionType: ObjectActionListType.MONITORING })]
                })]
        })
    ];
    statusType: StatusType = StatusType.status;
    statusInfoByType = new Map<StatusType, any>();
    selectedNode: GenericTreeNode;
    currentNavigationComponent: StatusNavigationContentComponent;
    currentProject: Project;

    constructor(
        private commonService: CommonService, private httpService: HttpService,
        private restService: RestService,
        private router: Router) {

        this.statusInfoByType.set(StatusType.status, { nodes: this.nodes });
    }

    ngAfterViewInit(): void {
        this.currentProject = this.commonService.currentProject;
        setTimeout(() => {
            this.statusTree.setData(this.statusInfoByType.get(this.statusType).nodes);
            const node = this.statusTree.getNodeBy(n => n.name === this.commonService.statusManagementContext.preselectedStatusType);
            if (node) {
                this.statusTree.selectNode(node);
            }

            this.selectedNode = this.statusTree.selectedNode;
        });

    }

    preselectSettingCallback = (node: GenericTreeNode): void => {
        const nodeToSelect = this.statusTree.getNodeBy(n => n.name === node.name);
        if (nodeToSelect) {
            this.statusTree.selectNode(node);
            this.selectedNode = this.statusTree.selectedNode;
        }
    }

    ngOnDestroy(): void {
        this.commonService.isExternalApp = false;
    }
}
